import React__default, { useRef } from 'react';
import { Animated } from 'react-native';

const AppFadeView = _ref => {
  let {
    fromValue = 0,
    toValue = 1,
    duration = 100,
    style,
    children
  } = _ref;
  const fadeAnim = useRef(new Animated.Value(fromValue)).current; // Initial value for opacity: 0

  React__default.useEffect(() => {
    Animated.timing(fadeAnim, {
      toValue,
      duration,
      useNativeDriver: false
    }).start();
  }, [fadeAnim, duration, toValue]);
  return /*#__PURE__*/React__default.createElement(Animated.View, {
    // Special animatable View
    style: [style, {
      opacity: fadeAnim
    } // Bind opacity to animated value
    ]
  }, children);
};
AppFadeView.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppFadeView",
  "props": {
    "fromValue": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Sets the opacity value the View starts the animation from"
    },
    "toValue": {
      "defaultValue": {
        "value": "1",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Sets the opacity value the View ends the animation with"
    },
    "duration": {
      "defaultValue": {
        "value": "100",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Sets the duration of the transition"
    },
    "style": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Sets the style of the overall view"
    },
    "children": {
      "required": false,
      "tsType": {
        "name": "ReactNode"
      },
      "description": "Children prop"
    }
  }
};

export { AppFadeView as A };
